import React from "react";
import { useParams } from "react-router-dom";

export default function MPGSSession() {
    const {sessionId} = useParams();

    React.useEffect(() => {
        //@ts-ignore
        window.Checkout.configure({
            session: {
              id: `${sessionId}`,
                 }
          });
          //@ts-ignore
          window.Checkout.showPaymentPage();
    }, []);

    return(
        <></>
    )
}